'use client'

import ImageBgLoading from '@component/imageBgLoading'
import { get, map, size } from 'lodash-es'
import { Swiper, SwiperSlide } from 'swiper/react'

export default function Cover({ data }) {

  const imageList = get(data, 'ossImages', [])
  return size(imageList) > 0 && (
    <Swiper className='mt-20'>
      {
        map(imageList, (item, idx) => (
          <SwiperSlide key={idx}>
            <ImageBgLoading src={item} width={1800} height={565} priority alt={data.name} className='w-full h-auto min-h-[240px] max-h-600 object-cover'></ImageBgLoading>
          </SwiperSlide>
        ))
      }
    </Swiper>
  )
}